import { Stack, Typography } from '@mui/material'
import ExportHistoryContainer from 'components/ExportHistoryContainer'
import mixpanel from 'mixpanel-browser'
import { useLayoutEffect } from 'react'

function ExportHistoryPage() {
  useLayoutEffect(() => {
    mixpanel.track_pageview(
      { page: 'Histórico de Exportações WhatsApp' },
      { event_name: 'Acesso - Histórico de Exportações' },
    )
  }, [])

  return (
    <Stack height="auto" gap="2rem" padding="1.5rem 4rem">
      <Stack direction="row" padding="0.5rem">
        <Typography sx={{ color: 'text.secondary' }}>
          {'Relatórios / Geral / '}
          <span style={{ color: 'text.secondary', ml: '0.3rem', fontWeight: 'bold' }}>Registro de exportações</span>
        </Typography>
      </Stack>
      <Stack sx={{ flexDirection: 'column', gap: '1.5rem' }}>
        <Typography
          data-id="title-export-history"
          variant="h1"
          sx={{
            fontSize: '2.25rem',
            fontWeight: 900,
          }}
        >
          Registro de exportações - WhatsApp
        </Typography>

        <Typography color="GrayText">
          Acompanhe o status das exportações de dados relacionadas ao relatório de Volume de disparos (HSM), com acesso
          rápido aos arquivos gerados.
        </Typography>
      </Stack>
      <ExportHistoryContainer />
    </Stack>
  )
}

export default ExportHistoryPage
